<template>
    <SupplierDetailTable :table-settings="concurrencyTenderTableSettings" :debounce="debounce"
        :sort-options="contractsSortOptions" ref="concurrency_data_table" :enable-search="false" :enable-sort="false"
         @row-clicked="(item) => {
                if (item.is_supplier) {
                    $router.push({
                        name: 'supplier-detail',
                        params: {
                            version: version,
                            hash: hash,
                            slug: item.slug
                        }
                    });
                }
            }
            ">
        <template v-slot:cell(flags_count)="row">
            <span class="badge badge-pill badge-danger">{{ row.value }}</span>
        </template>

        <template v-slot:cell(flags)="row">
            <FlagDetailRowToggler :row="row" :callback="toggleConcurrencyRowDetail" />
        </template>

        <template v-slot:row-details="row">
            <FlagDetailRow :row="row" :version="version" />
        </template>
    </SupplierDetailTable>
</template>

<script>
import SupplierDetailTable from "@/components/SupplierDetailTable.vue";
import dataTableMixin from "@/plugins/dataTableMixin.js";
import tableSettingsMixin from "@/plugins/tableSettingsMixin.js";
import FlagDetailRowToggler from "@/components/FlagDetailRowToggler.vue";
import FlagDetailRow from "@/components/FlagDetailRow.vue";
export default {
    props: {
        version: { required: true },
        hash: { required: true },
        typeId: { required: true },
        tenderSlug: { required: true },
        debounce: { type: Number, required: false, default: 700 }
    },
    components: {
        SupplierDetailTable,
        FlagDetailRowToggler,
        FlagDetailRow
    },
    mixins: [dataTableMixin, tableSettingsMixin],
    data: function (data) {
        return {
            concurrencyTenderTableSettings: {
                isBusy: false,
                initialized: false,
                selectedSortOptionValue: 0,
                filter: {},
                emptyText: this.$t("table.empty"),
                emptyFilteredText: this.$t("table.filter.empty"),
                items: this.concurrencyTableDataProvider,
                tbodyTrClass: (item) => (item && item.is_supplier ? "clickable" : ""),
                fields: [
                    {
                        key: "name",
                        label: this.$t("tenderDetail.concurrency.table.head.name"),
                        thClass: "text-left text-nowrap text-xl-nowrap",
                        class: "text-left",
                        isActive: true
                    },
                    {
                        key: "flags",
                        label: this.$t("tenderDetail.concurrency.table.head.flags"),
                        thClass: "text-right",
                        tdClass: "text-right detailsButtonColumn",
                        isActive: true
                    },
                ],
                filterTimeout: null,
                filterExpanded: false,
                orderingExpanded: false,
                fieldsExpanded: false,
                flagsExpanded: false,
            }
        }
    },
    methods: {
        concurrencyTableDataProvider: function (ctx) {
            var params = this.initRequestParams(ctx);

            params["tender_slug"] = this.tenderSlug;
            params[`${this.version}_hash`] = this.hash;

            return this.$store.getters.api
                .get("get_concurrency/", { params: params })
                .then((response) => {
                    var data = response.data.concurrency;
                    this.$refs.concurrency_data_table.setTotalRows(response.data.total_count);
                    return data;
                })
                .catch((e) => {
                    console.dir(e);
                    return [];
                });
        },
        toggleConcurrencyRowDetail: function(row) {
            row.toggleDetails();
        },
    }
}
</script>